import { consumeItemApi, updateUserSkinApi } from '@api'
import { ApiService, ApiServiceGetResponse } from '@services'
import { AchievementSlug } from '@shared'
import {
  InventoryCard,
  useBattlePass,
  useInventory,
  useInventoryStoreBase,
  useOverlay,
  useUser,
  useAchievementsStore,
  useUserBank,
  MainInventoryBackendCard,
} from '@store'

export async function checkUserLevel(stars: number | null) {
  const bpInfo = useBattlePass.getState().data
  const userLevel = useUser.getState().profile?.battlepassLevel

  if (userLevel !== undefined && bpInfo && stars) {
    const nextLevelInfo = bpInfo.levels.find(
      (item) => item.level === userLevel + 1
    )

    if (nextLevelInfo && stars === nextLevelInfo.stars) {
      useOverlay.getState().actions.setOverlayQueue([
        {
          type: 'info',
          payload: {
            image:
              'https://not-platform.fra1.cdn.digitaloceanspaces.com/glance/level_up.png',
            title: 'levelUpOverlay.title',
            description: 'levelUpOverlay.text',
            icon: 'gift',
            buttonText: 'levelUpOverlay.accept',
          },
        },
      ])

      await ApiService.poll(
        async () => {
          await useUser.getState().actions.fetchProfile()
          return useUser.getState().profile
        },
        (profile) => profile?.battlepassLevel === userLevel + 1
      )

      await Promise.all([
        useBattlePass.getState().actions.getBattlePass(),
        useInventoryStoreBase.getState().actions.getItems(),
      ])
    }
  }
}

export const updateUserSkinService = async (card: InventoryCard) => {
  const { ok, data } = await updateUserSkinApi({
    ...(card.displayType === 'avatar' && { avatar: card.id }),
    ...(card.displayType === 'avatar_shell' && { avatarEffect: card.id }),
    ...(card.displayType === 'star_effect' && { star: card.id }),
    ...(card.displayType === 'spiral_effect' && { spiral: card.id }),
  })
  if (ok) {
    await useUser.getState().actions.fetchProfile()
    await useAchievementsStore.getState().actions.unlockAchievement(AchievementSlug.FACE_SELECTED)
  }
  return { ok, data }
}

export async function consumeCardService(
  card: InventoryCard,
  additionalData?: Record<string, any>
): Promise<ApiServiceGetResponse<{ reward_items: MainInventoryBackendCard[] }>> {
  try {
    const { data, ok } = await consumeItemApi(card.id, additionalData)
    if (ok) {
      if (card.type === 'booster') {
        useUserBank.getState().actions.getGetTapsBalance()

        if (card.displayType === 'chest' || card.displayType === 'lootbox') {
          useInventory.getState().actions.getItems()
        }
      }
    }
    return { ok, data }
  } catch (e) {
    return { ok: false }
  }
}
